import React from 'react';
import { TableCell, TableRow, Table, TableBody } from '@material-ui/core';
import dayjs from 'dayjs';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

export const StreamChatNotification = ({ notification, handleNotificationRead, userTimeZone, handleCloseMenu }) => {
	const { data } = notification;
	const navigate = useNavigate();

	const isMention = data.body?.toLowerCase().includes('you were mentioned');

	// handle both new notifications and saved notifications from db
	const channelType = data.channelType || data.channel_type;
	const channelId = data.channelId || data.channel_id;

	const handleClick = () => {
		const route =
			channelType === 'admin-messaging' ? `/messaging/admin/chat/${channelId}` : `/messaging/teacher/chat/${channelId}`;
		handleNotificationRead(notification);
		handleCloseMenu();
		navigate(route);
	};

	return (
		<Table>
			<TableBody>
				<TableRow>
					<TableCell
						className="cursor-pointer notification-wrapper"
						onClick={handleClick}
						style={{
							backgroundColor: `${notification.read_at ? '' : '#F0F9FE'}`,
							width: '450px',
						}}
					>
						<div className="flex" style={{ gap: '5px' }}>
							<div>
								<div
									className="bg-white rounded-full size-[35px] border border-pd-blue-new flex items-center justify-center"
									style={{
										background: 'linear-gradient(90deg, rgba(244, 249, 255, 1) 0%, rgba(208, 226, 244, 1) 100%)',
									}}
								>
									<ChatBubbleLeftRightIcon className="size-[22px] text-pd-blue-new" />
								</div>
							</div>
							<div className="flex flex-col" style={{ flexGrow: 1 }}>
								<span className="font-bold" style={{ fontSize: '14px', marginBottom: '4px' }}>
									{isMention ? 'You were mentioned' : 'New message'}
								</span>
								<span style={{ fontSize: '12px' }}>
									<span>{data.body}</span>
								</span>
							</div>
							<div className="flex flex-col items-end" style={{ flexShrink: 0 }}>
								<span style={{ fontSize: '11px', marginTop: '4px' }}>
									{dayjs.utc(notification.created_at).tz(userTimeZone).format('MMMM D, YYYY, hh:mm A')}
								</span>
							</div>
						</div>
					</TableCell>
				</TableRow>
			</TableBody>
		</Table>
	);
};
